<template>
  <v-card class="scrollable-div" elevation="3">
    <v-card-title class="headline">
      <v-typography variant="h5" class="modal-title">Update Employee</v-typography>
      <v-btn icon @click="emit('close')" class="square-btn">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-form ref="form" v-if="employee" :key="formKey" @submit.prevent="submitForm">
        <!-- <v-text-field v-model="state.id" :counter="10" :error-messages="v$.name.$errors.map((e) => e.$message)" label="ID" required @blur="v$.name.$touch" @input="v$.name.$touch"></v-text-field> -->
        <input type="hidden" v-model="state.id" />
        <v-text-field v-model="state.name" :counter="10" :error-messages="v$.name.$errors.map((e) => e.$message)" label="Name" required @blur="v$.name.$touch" @input="v$.name.$touch" />

     

        <!-- <v-select v-model="state.gender" :items="[
          { value: 'male', name: 'Male' },
          { value: 'female', name: 'Female' },
          { value: 'others', name: 'Others' }
        ]" item-title="name" item-value="value" :error-messages="v$.gender.$errors.map((e) => e.$message)" label="Gender"
          required @blur="v$.gender.$touch" @input="v$.gender.$touch" /> -->

        <v-select v-model="state.blood_group" :items="[
          { value: 'o+', name: 'O+' },
          { value: 'o-', name: 'O-' },
          { value: 'a+', name: 'A+' },
          { value: 'a-', name: 'A-' },
          { value: 'b+', name: 'B+' },
          { value: 'b-', name: 'B-' },
          { value: 'ab+', name: 'AB+' },
          { value: 'ab-', name: 'AB-' }
        ]" item-title="name" item-value="value" :error-messages="v$.blood_group.$errors.map((e) => e.$message)"
          label="Blood Group" required @blur="v$.blood_group.$touch" @input="v$.blood_group.$touch" />

             <v-text-field v-model="state.address" :counter="10" :error-messages="v$.name.$errors.map((e) => e.$message)" label="Address" required @blur="v$.address.$touch" @input="v$.address.$touch" />

        <!-- <v-select v-model="state.teaching_level.name" :items="[
          { value: 'montessori', name: 'Montessori' },
          { value: 'primary', name: 'Primary Level' },
          { value: 'lower_secondary', name: 'Lower Secondary' },
          { value: 'secondary', name: 'Secondary Level' },
          { value: 'higher_secondary', name: 'Higher Secondary' },
          { value: 'bachelor', name: 'Bachelor' },
          { value: 'master', name: 'Masters' }
        ]" item-title="name" item-value="value" :error-messages="v$.teaching_level.$errors.map((e) => e.$message)"
          label="Teaching Level" required @blur="v$.teaching_level.$touch" @input="v$.teaching_level.$touch" /> -->
<!-- 
        <v-select v-model="state.category.name" :items="[
          { value: '1st', name: '1st Class' },
          { value: '2nd', name: '2nd Class' },
          { value: '3rd', name: '3rd Class' }
        ]" item-title="name" item-value="value" label="Category" required @blur="v$.category.$touch"
          @input="v$.category.$touch" /> -->


        <v-text-field v-model="state.designation" :counter="10"
          :error-messages="v$.designation.$errors.map((e) => e.$message)" label="Designation" required
          @blur="v$.designation.$touch" @input="v$.designation.$touch"></v-text-field>

        <v-text-field v-model="state.contact" :counter="15" :error-messages="v$.contact.$errors.map((e) => e.$message)"
          label="Contact" required @blur="v$.contact.$touch" @input="v$.contact.$touch"></v-text-field>
       <template v-if="state.image">
<a :href="state.image" target="_blank">
  <v-img
    :src="state.image"
    class="student-image mrr-10"
    alt="Employee Image"
  />
</a>
</template>
        <v-file-input v-model="state.image" accept="image/*" label="Upload Image"
          @update:model-value="handleImageChange">
        </v-file-input>
        <v-row class="justify-end m-2">
          <v-btn class="me-2" @click="submitForm">Submit</v-btn>
          <!-- <v-btn @click="clear">Clear</v-btn> -->
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { ref } from "vue";

import { reactive, defineProps, defineEmits } from "vue";
import { updateEmployee } from "@/services/apiServices";
import { useVuelidate } from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";

const props = defineProps({
  employee: {
    type: Object,
    required: true,
  },
});

const initialState = {
  id: "",
  name: "",
  address: "",
  image: null,
  gender: "",
  blood_group: "",
  teaching_level: { value: "", name: "" },
  category: { value: "", name: "" },
  designation: "",
  contact: "",
};
const state = reactive({
  ...initialState,
  ...props.employee,
});
const emit = defineEmits(["updateEmployeed", "clear", "close"]);



const rules = {
  id: { required },
  name: { required },
  address: { required },
  gender: { required },
  blood_group: { required },
  teaching_level: { required },
  category: { required },
  designation: { required },
  contact: { required },
};

const v$ = useVuelidate(rules, state);

const handleImageChange = (event) => {
  // console.log("File:", file);
  const file = event.target.files[0];
  // console.log("File:", file);
  if (file) {
    state.value.image = file; // Set it to the student data
  }
};


const submitForm = async () => {
  v$.value.$validate();
  if (v$.value.$invalid) return;

  const formData = new FormData();
  Object.keys(state).forEach((key) => {
    // If the value is an object, append its value field
    if (typeof state[key] === "object" && state[key] !== null && state[key].hasOwnProperty('value')) {
      formData.append(key, state[key].value); // Append the 'value' for object types
    } else {
      formData.append(key, state[key]); // Directly append non-object values
    }
  });

  if (state.image && state.image instanceof File) {
    formData.append("image", state.image);
  } else {
    formData.delete("image");
  }

  try {
    const response = await updateEmployee(formData);

    if (response) {
      emit("updateEmployeed", response);
    } else {
      console.error("Unexpected response format:", response);
    }
  } catch (error) {
    console.error("Update Error:", error.response?.data || error.message);
  }
};


// const clear = () => {
//   v$.value.$reset();
//   for (const [key] of Object.entries(props.initialState)) {
//     state[key] = props.initialState[key];
//   }
//   emit('clear'); // Emit clear event to parent
// };
const formKey = ref(0);
const clear = () => {
  v$.value.$reset();
  Object.assign(state, initialState);
  formKey.value++; // Force re-render to reset
  emit("clear");
};
</script>

<style>
.headline {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  background-color: #ddffbe;
  padding: 0.8rem 1.4rem;
  border-bottom: 0 solid #ebe9f1;
  border-top-left-radius: 0.357rem;
  border-top-right-radius: 0.357rem;
}

.v-theme--dark .headline {
  background-color: rgba(114, 33, 33, 0.438) !important;
  border-radius: 8px;
}

.modal-title {
  font-size: 1.3rem;
  margin-bottom: 0;
  line-height: 1.45;
}

.square-btn {
  width: 40px;
  height: 40px;
  background-color: rgb(221, 198, 245);
}
</style>
